import { render, staticRenderFns } from "./ParamSubGroups.vue?vue&type=template&id=5113f980&scoped=true&"
import script from "./ParamSubGroups.vue?vue&type=script&lang=js&"
export * from "./ParamSubGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5113f980",
  null
  
)

export default component.exports